/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Loading_DocumentInputs */



/**
* | output |
* | --- |
* | "Loading document..." |
*
* @param {Spaces_Fileviewer_Loading_DocumentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_loading_document = /** @type {((inputs?: Spaces_Fileviewer_Loading_DocumentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Loading_DocumentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokument wird geladen...")
	return /** @type {LocalizedString} */ ("Loading document...")
});